import Logger from "./Logger";

// Extend the Window interface to include gtag
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

interface ITrackingEventArgs {
  category?: string
  action: string
  value?: number
  label?: string
}

export enum TrackingCodes {
  ToDo
}

class Tracking {
  static trackingId: string = ""
  static initialized = false
  static UUIDPattern = new RegExp(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/)

  static initialize(trackingId: string, options: any) {
    if (!trackingId) {
      return
    }
    // Try using the config for each id to get multiple trackers working
    // this.gtag('config', trackingId)
    // this.gtag('config', 'AW-681142633')

    this.gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });
    this.gtag("consent", "update", {
      // ad_storage: 'granted',
      // ad_user_data: 'granted',
      // ad_personalization: 'granted',
      analytics_storage: "granted",
    });
    // ReactGA.gtag('config', 'AW-681142633')
    this.initialized = true
    this.trackingId = trackingId
    Logger.debug(`Tracking.initialize: ${trackingId} options: ${JSON.stringify(options)}`)
  }

  static set(name: string, args: any) {
    if (this.initialized) {
      this.gtag("set", name, args)
      Logger.debug(`Tracking.set: ${name}: ${JSON.stringify(args)}`)
    }
  }

  static setUserId(userId: string) {
    if (this.initialized) {
      this.gtag("config", this.trackingId, {user_id: userId})
    }
  }

  static pageView(path: string) {
    if (this.initialized) {
      const cleaned = Tracking.cleanPath(path)
      this.gtag("event", "page_view", {page_location: cleaned})
      Logger.debug(`Tracking.pageView: ${cleaned}`)
    }
  }

  static modalView(name: string) {
    if (this.initialized) {
      // TODO: ReactGA.modalview(name)
      Logger.debug(`Tracking.modalview: ${name}`)
    }
  }

  static event(args: ITrackingEventArgs) {
    if (this.initialized) {
      const eventArgs = {
        event_category: args.category || Tracking.cleanPath(window.location.pathname),
        value: args.value,
        event_label: args.label
      }
      this.gtag("event", args.action, eventArgs)
    }
    Logger.debug(`Tracking.event: ${JSON.stringify(args)}`)
  }

  static gtag(type: string, action: string, params?: any) {
    if (this.initialized && window.gtag !== undefined) {
      window.gtag(type, action, params)
    }
    Logger.debug(`Tracking.gtag: ${type}, ${action}`, params)
  }

  static cleanPath(path: string) {
    // Clean out the UUIDs from the path for analytic reporting
    const cleaned = path.replace(Tracking.UUIDPattern, "uuid")
    return cleaned
  }

}

export default Tracking